import { Users, UserCog, School, Car, CreditCard, UsersRound } from "lucide-react";

/**
 * Config-driven definition of each result category shown in
 * GlobalSearchDialog — one entry per `results.<key>` shape returned by
 * `/api/search`. Keeping this as data (rather than repeated JSX blocks)
 * is what lets GlobalSearchDialog.js stay a thin renderer.
 */
export const SEARCH_RESULT_GROUPS = [
  {
    key: "students",
    heading: "Students",
    icon: Users,
    getPath: (item) => `/students/${item.id}`,
    renderLabel: (item) => item.full_name,
  },
  {
    key: "parents",
    heading: "Parents",
    icon: UsersRound,
    getPath: () => `/parents`,
    renderLabel: (item) => (
      <>
        {item.full_name} <span className="text-muted-foreground ml-1">{item.email}</span>
      </>
    ),
  },
  {
    key: "instructors",
    heading: "Instructors",
    icon: UserCog,
    getPath: (item) => `/instructors/${item.id}`,
    renderLabel: (item) => item.full_name,
  },
  {
    key: "classrooms",
    heading: "Classrooms",
    icon: School,
    getPath: (item) => `/classrooms/${item.id}`,
    renderLabel: (item) => item.class_name,
  },
  {
    key: "vehicles",
    heading: "Vehicles",
    icon: Car,
    getPath: (item) => `/vehicles/${item.id}`,
    renderLabel: (item) => `${item.make} ${item.model} - ${item.license_plate}`,
  },
  {
    key: "payments",
    heading: "Payments",
    icon: CreditCard,
    getPath: () => `/payments`,
    renderLabel: (item) => `$${item.amount?.toFixed(2)} - ${item.memo || item.method}`,
  },
];
